import { InitClient,GetByParas,Post,PostWithParas,PostNoParas} from "../ZeusAPIClient.js"


//二次登陆
async function UserLogin(userCode,password){
    var paras={
        userCode:userCode,
        password:password
    }
    var data=await PostWithParas('6c90f38f-5d0d-427a-ae96-f65423c62aca',paras,{});
    return data;
  } 
  
  //修改二次登陆密码
  async function UpdateSecondPwd( userCode, oldPwd,newPwd) {
      var data = {
        userCode: userCode,
        oldPwd: oldPwd,
        newPwd:newPwd
      };
    //   console.log(data);
       return await PostWithParas("ffef250c-08e3-4422-b40a-3c367f7d724e", data,{});
     // return await PostWithParas("d32945bd-89b6-4bb0-9f06-15b5b25ed30d","", data);
  }
  
//结果版本列表
async function GetInfoList( p, pageSize) {
    var data = {
        p: p,
        pageSize: pageSize
    };
    // console.log(data);
     return await PostWithParas("6dd0f6b5-fbb9-43ce-a93a-6507a626c606", data,{});
   // return await PostWithParas("d32945bd-89b6-4bb0-9f06-15b5b25ed30d","", data);
}

//发放或撤回
async function Grant(resultInfoId,grantStatus,other,userCode){
    var para = {
        resultInfoId: resultInfoId,//当前操作数据
        GrantStatus: grantStatus,//当前状态 2撤回  1发放
        userCode:userCode//当前操作人
    };
    // console.log('para',para);
    // console.log('other',other);
    return await PostWithParas("7356e16e-d41d-4853-8bc0-c69b23811b12", para,other);
}

//15ef47c2-b68e-4087-8da6-e5f3fa3212af
//获取工资条全部发放人员
async function GetUserList(infoId){
    var para = {
        infoId: infoId//当前操作数据
    };
    // console.log(data);
     return await PostWithParas("15ef47c2-b68e-4087-8da6-e5f3fa3212af", para,{});
}

//单独发放工资条
async function SendOther(infoId,userCode,trueName){
    var para = {
        InfoId: infoId,//当前操作数据
        Other:userCode,//接收人工号
        TrueName:trueName//操作人姓名
    };
    // console.log(data);
    return await PostWithParas("61523c2f-cc14-49b2-a5ac-8da01e2e648f", para,{});
}

//结果版本列表
async function GetList( p,PId,title,people, pageSize,type) {
    var data = {
        p: p,
        PId:PId,
        title:title,
        people:people,
        pageSize: pageSize,
        type:type
    };
     return await PostWithParas("3b14abf8-09f8-460f-a4e0-902eb2a1fa57", {},data);
}
  


//获取详细信息
async function LookResult(id){
    var data={
        id:id
    }
    return await GetByParas('0f335a0e-05c8-41c1-b349-18279e2a09ed',data);
}

  
export {
    UserLogin,
    UpdateSecondPwd,
    GetInfoList,
    GetList,
    LookResult,
    Grant,
    GetUserList,
    SendOther
}